/** @format */

import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import SplashScreen from "./components/SplashScreen";
import Dashboard from "./pages/Dashboard";
import CollectionPage from "./pages/CollectionPage";
import BlogCollectionPage from "./pages/BlogCollectionPage";
import CourseCollectionPage from "./pages/CourseCollectionPage";
import SubcollectionPage from "./pages/SubcollectionPage";

import UsersPage from "./pages/UsersPage";
import EnrolledStudentsPage from "./pages/EnrolledStudentsPage";
import PendingUsersPage from "./pages/PendingUsersPage";
import BookReviewsPage from "./pages/BookReviewsPage";
import BooksPage from "./pages/BooksPage";
import CategoriesPage from "./pages/CategoriesPage";
import TagsPage from "./pages/TagsPage";
import ClassroomsPage from "./pages/ClassroomsPage";
import FreeResourcesPage from "./pages/FreeResourcesPage";
import WithdrawalsPage from "./pages/WithdrawalsPage";
import PaymentsPage from "./pages/PaymentsPage";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import SignIn from "./pages/SignIn";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route
                        path="/collection/blogs"
                        element={<BlogCollectionPage />}
                      />
                      <Route
                        path="/collection/courses"
                        element={<CourseCollectionPage />}
                      />
                      <Route path="/collection/books" element={<BooksPage />} />
                      <Route path="/classrooms" element={<ClassroomsPage />} />
                      <Route
                        path="/free-resources"
                        element={<FreeResourcesPage />}
                      />
                      <Route
                        path="/collection/categories"
                        element={<CategoriesPage />}
                      />
                      <Route path="/collection/tags" element={<TagsPage />} />

                      {/* Admin-only routes */}
                      <Route
                        path="/collection/users"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <UsersPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/enrolled-students"
                        element={<EnrolledStudentsPage />}
                      />
                      <Route
                        path="/pending-users"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <PendingUsersPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/collection/BooksReviews"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <BookReviewsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/withdrawals"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <WithdrawalsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/payments"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <PaymentsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/announcements"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <AnnouncementsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/collection/:collectionName"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <CollectionPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/collection/:collectionName/:documentId/:subcollectionName"
                        element={
                          <ProtectedRoute requiredRole="admin">
                            <SubcollectionPage />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: "#363636",
                color: "#fff",
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
